import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  takePlo4SeatService,
  takePlo4ActionService,
  updatePlo4PlayerSittingStatusService,
  updatePlo4PlayerSitOutNextBBService,
  updatePlo4BuyInAmountService,
  changePlo4SeatService,
  getPlo4GameTablesService,
  runItTwiceDecisionService
} from 'network/services/Plo4GameManagement.service'

export const getPlo4GameTablesThunk = createAsyncThunk(
  'plo4/getGameTables',
  async ({ data}, { rejectWithValue }) => {
    try {
      const response = await getPlo4GameTablesService(data)
      return response
    } catch (error) {
      return rejectWithValue('Failed to fetch game tables')
    }
  }
)

export const takePlo4SeatThunk = createAsyncThunk(
  'plo4/takeSeat',
  async (data, { rejectWithValue }) => {
    try {
      const response = await takePlo4SeatService(data)
      return response.data?.data || response.data
    } catch (error) {
      console.error('Error taking Plo4 seat:', error)
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to take seat')
    }
  }
)

export const takePlo4ActionThunk = createAsyncThunk(
  'plo4/takeAction',
  async (data, { rejectWithValue }) => {
    try {
      const response = await takePlo4ActionService(data)
      return response.data?.data || response.data
    } catch (error) {
      console.error('Error taking Plo4 action:', error)
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to take action')
    }
  }
)

export const updatePlo4PlayerSittingStatusThunk = createAsyncThunk(
  'plo4/updatePlayerSittingStatus',
  async (data, { rejectWithValue }) => {
    try {
      const response = await updatePlo4PlayerSittingStatusService(data)
      return response.data?.data || response.data
    } catch (error) {
      console.error('Error updating Plo4 player sitting status:', error)
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to update sitting status')
    }
  }
)

export const updatePlo4PlayerSitOutNextBBThunk = createAsyncThunk(
  'plo4/updatePlayerSitOutNextBB',
  async (data, { rejectWithValue }) => {
    try {
      const response = await updatePlo4PlayerSitOutNextBBService(data)
      return response.data?.data || response.data
    } catch (error) {
      console.error('Error updating Plo4 player sit out next BB:', error)
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to update sit out next BB')
    }
  }
)

export const updatePlo4BuyInAmountThunk = createAsyncThunk(
  'plo4/updateBuyInAmount',
  async (data, { rejectWithValue }) => {
    try {
      const response = await updatePlo4BuyInAmountService(data)
      return response.data?.data || response.data
    } catch (error) {
      console.error('Error updating Plo4 buy-in amount:', error)
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to update buy-in amount')
    }
  }
)

export const changePlo4SeatThunk = createAsyncThunk(
  'plo4/changeSeat',
  async (data, { rejectWithValue }) => {
    try {
      const response = await changePlo4SeatService(data)
      return response.data?.data || response.data
    } catch (error) {
      console.error('Error changing Plo4 seat:', error)
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to change seat')
    }
  }
)

export const runItTwiceDecisionThunk = createAsyncThunk(
  'plo4/runItTwiceDecision',
  async (data, { rejectWithValue }) => {
    try {
      const response = await runItTwiceDecisionService(data)
      return response.data?.data || response.data
    } catch (error) {
      console.error('Error submitting run it twice decision:', error)
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to submit decision')
    }
  }
)
